<div id="loading" class="mb-3" *ngIf="loading">
    <i class="fas fa-spinner fa-spin me-1"></i>
    <span>Cargando contenido...</span>
</div>
<editor [id]="id" [(ngModel)]="content" [init]="tinymceConfig" (onInit)="init()"></editor>